import { Y_COUNTER } from "@/config.ts";

export enum EGoal {
  merchant_click = "merchant_click",
  coupon_click = "coupon_click",
  offer_click = "offer_click"
}

export const addGoal = async (name: EGoal): Promise<void> => {
  return new Promise<void>(res => {
    if (window[Y_COUNTER]) {
      window[Y_COUNTER].reachGoal(name, {}, () => {
        console.log(`Conversion callback from '${name}' goal`);
        res();
      });
    } else {
      res();
    }
  });
};
